module.exports = __webpack_public_path__ + "img/asmntproginactivehover.de7dc3a2.svg";